import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-loading",
  "use": "svg-icon-loading-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-loading\"><g stroke-linecap=\"round\" stroke=\"#717B7F\" stroke-linejoin=\"round\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M12.976 9.57l3.791.508.454-3.802\" stroke-width=\"1.5\" /><path d=\"M15.655 13.693a5.172 5.172 0 01-3.308 2.246c-2.798.583-5.556-1.131-6.159-3.829-.603-2.699 1.178-5.36 3.977-5.943 2.51-.524 4.987.801 5.906 3.026\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol